// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  connectNowAPI: 'https://gateway.test.kayool.com/kayool-shop-service',
  dashboardURL: 'https://connectnowdashboarddevsite.kayool.com/#/',
  SECRET_KEY: 'kC0nnectDev@2o23', 
  kayoolUserServicePath: `https://gateway.test.kayool.com/user-service`,
  connectNowCompanyId:'1103267287302438912'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
